<template>
  <base-input :rules="internalRules" :errors="errors">
    <div
      :class="[
        'tw-relative tw-border tw-rounded-md focus-within:tw-ring-1 tw-ring-0 tw-flex tw-items-center tw-transition-all tw-ease-in-out tw-duration-100 tw-bg-white tw-z-10 tw-mt-1',
        `focus-within:tw-ring-${focusColor} focus-within:tw-border-${focusColor} tw-border-${borderColor}`,
      ]"
    >
      <label :class="['tw-absolute tw--top-2 tw-left-2 tw--mt-px tw-inline-block tw-px-1 tw-bg-white tw-text-xs tw-font-normal', `tw-text-${labelColor}`]" v-if="label">{{
        label
      }}</label>
      <textarea
        v-bind="$attrs"
        v-on="inputListeners"
        type="text"
        :class="[
          'form-input tw-flex-grow tw-block tw-w-full tw-border-0 tw-px-3 tw-py-2 tw-rounded-md tw-text-gray-900 focus:tw-ring-0 tw-font-light',
          `tw-placeholder-${placeholderColor} sm:tw-text-${size}`,
        ]"
        :placeholder="placeholder"
        @blur="validate"
        :value="value"
        :rows="rows"
      />
    </div>
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  mixins: [validatable],
  components: {
    BaseInput,
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    size: {
      type: String,
      default: "sm",
    },
    rows: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    inputListeners: function() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.$emit("input", event.target.value);
        },
      });
    },
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("input", null);
    },
  },
};
</script>
